import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/jamm/Header";
import Footer from "@/components/jamm/Footer";
import WhatsAppFloat from "@/components/jamm/WhatsAppFloat";
import ProtectedRoute from "@/components/jamm/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Accompagnateurs from "@/pages/Accompagnateurs";
import AccompagnateurDetail from "@/pages/AccompagnateurDetail";
import Reservation from "@/pages/Reservation";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSettings from "@/pages/AdminSettings";
import Tarifs from "@/pages/Tarifs";
import Confidentialite from "@/pages/Confidentialite";
import Seance from "@/pages/Seance";

function Layout({ children }) {
  return (
    <>
      <Header />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

function GoogleAnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <AuthProvider>
          <GoogleAnalyticsTracker />
          <Routes>
            <Route path="/" element={<Layout><Landing /></Layout>} />
            <Route path="/accompagnateurs" element={<Layout><Accompagnateurs /></Layout>} />
            <Route path="/accompagnateurs/:id" element={<Layout><AccompagnateurDetail /></Layout>} />
            <Route
              path="/tarifs"
              element={
                <ProtectedRoute>
                  <Layout><Tarifs /></Layout>
                </ProtectedRoute>
              }
            />
            <Route path="/confidentialite" element={<Layout><Confidentialite /></Layout>} />
            <Route path="/login" element={<Layout><Login /></Layout>} />
            <Route path="/register" element={<Layout><Register /></Layout>} />
            <Route path="/mot-de-passe-oublie" element={<Layout><ForgotPassword /></Layout>} />
            <Route path="/reset-password" element={<Layout><ResetPassword /></Layout>} />
            <Route
              path="/reservation/:id"
              element={
                <ProtectedRoute>
                  <Layout><Reservation /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout><Dashboard /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/seance/:id"
              element={
                <ProtectedRoute>
                  <Layout><Seance /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute role={["admin", "superadmin"]}>
                  <Layout><AdminDashboard /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/parametres"
              element={
                <ProtectedRoute role={["superadmin"]}>
                  <Layout><AdminSettings /></Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster richColors position="top-center" />
        </AuthProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}
